export const AdCampaignPlacementType = {
  LANDING_PAGE_SPONSORED_HIGHLIGHT: 'landing_page_sponsored_highlight',
  POST: 'post',
  STORIES: 'stories'
}
